import { MutationTree } from "vuex";
import Vue from "vue";
import { DispatchState, Guard, PatrolZone, GuardType, AlarmFilter, SetGuardTypePayload } from "./types";
import { getDefaultState } from "./state";

export const mutations: MutationTree<DispatchState> = {
	setGuards(state, data: Guard[]) {
		state.Guards = data;
	},

	setGuardTypes(state, data: GuardType[]) {
		state.GuardTypes = data;
	},

	setGuardsForFilter(state, data: Guard[]) {
		state.GuardsForFilter = data;
	},

	setEventGuards(state, data: any) {
		state.EventGuards = data;
	},

	setEventLocation(state, data: string) {
		state.EventLocation = data;
	},

	addNewGuard(state, data: Guard) {
		state.Guards.push(data);
	},

	updateGuard(state, data: Guard) {
		let index = state.Guards.findIndex((x: Guard) => x.guardID == data.guardID);
		if(state.Guards[index])
			Vue.set(state.Guards, index, data);
	},

	setGuardType(state, data: SetGuardTypePayload) {
		let index = state.Guards.findIndex((x: Guard) => x.guardID == data.guardID);
		if(state.Guards[index]) {
			state.Guards[index].dispatchGuardTypeID = data.dispatchGuardTypeID;
		}
	},

	deleteGuard(state, data: Guard) {
		Vue.delete(state.Guards, state.Guards.indexOf(data));
	},

	addPatrolZone(state, zone: PatrolZone) {
		state.PatrolZones.push(zone);
	},

	deletePatrolZone(state, zone: PatrolZone) {
		Vue.delete(state.PatrolZones, state.PatrolZones.indexOf(zone));
	},

	addGuardToPatrolZone(state, zone: PatrolZone) {
		if (typeof zone.numberOfGuardsAssigned === "undefined") {
			zone.numberOfGuardsAssigned = 0;
		}

		zone.numberOfGuardsAssigned++;
	},

	removeGuardFromPatrolZone(state, zone: PatrolZone) {
		if (!zone.numberOfGuardsAssigned) {
			zone.numberOfGuardsAssigned = 0;
		}

		zone.numberOfGuardsAssigned--;
	},

	updatePatrolZone(state, { zone, data }) {
		zone.title = data.title;
		zone.zonePath = data.zonePath;
	},

	setPatrolZones(state, data: PatrolZone[]) {
		state.PatrolZones = data;
	},

	setDispatchedGuard(state, { guardID, status }) {
		switch (status) {
			// Available
			case 1: {
				const dispatchGuardIndex = state.DispatchedGuards.findIndex(
					g => g.guardID === guardID
				);
				const guardToUpdate =
					state.DispatchedGuards[dispatchGuardIndex];
				guardToUpdate.status = status;
				state.DispatchedGuards.splice(dispatchGuardIndex, 1);
				state.EventGuards.push(guardToUpdate);
				break;
			}
			// On route
			case 2: {
				const eventGuardIndex = state.EventGuards.findIndex(
					g => g.guardID === guardID
				);
				const guardToUpdate = state.EventGuards[eventGuardIndex];
				guardToUpdate.status = status;
				state.EventGuards.splice(eventGuardIndex, 1);
				state.DispatchedGuards.push(guardToUpdate);
				break;
			}
			// Arrived
			case 3: {
				const dispatchGuardIndex = state.DispatchedGuards.findIndex(
					g => g.guardID === guardID
				);
				const guardToUpdate =
					state.DispatchedGuards[dispatchGuardIndex];
				guardToUpdate.status = status;
				Vue.set(
					state.DispatchedGuards,
					dispatchGuardIndex,
					guardToUpdate
				);
				break;
			}
			default: {
				break;
			}
		}
	},

	setDispatchedGuards(state, guards: Guard[]) {
		state.DispatchedGuards = guards;
	},

	setGuardsCallsignListFilter(state, filterPhrase: string) {
		state.GuardsCallsignListFilter = filterPhrase;
	},

	setGuardsPatrolZoneListFilter(state, patrolZoneID: number) {
		state.GuardsPatrolZoneListFilter = patrolZoneID;
	},

	updateDispatchedGuards(state, { eventGuards, dispatchedGuards }) {
		state.EventGuards = eventGuards;
		state.DispatchedGuards = dispatchedGuards;
	},

	setAlarmFilters(state, data: AlarmFilter[]) {
		state.AlarmFilters = data;
	},

	setBulkEditDialogOpen(state, open: boolean) {
		state.BulkEditDialogOpen = open;
	},

	setBulkUploadDialogOpen(state, open: boolean) {
		state.BulkUploadDialogOpen = open;
	},

	resetState(state) {
		Object.assign(state, getDefaultState());
	}
};
